module.exports = __webpack_public_path__ + "img/missing-online-checkin.fed523ae.svg";